import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

export default () => {//this component shows the origin,destination addresses and extra stops between them
    let IV1_PageDetails = useContext(RecordsManagementContext).IV1_PageDetails
    const AddressRecord = (props) =>{
        return(
            <>
                <div className="col residence_col">
                    <b>{props.addressType}</b>
                </div>
                <div className="col address">
                    {props.address}<br/>
                    {props.description ? props.description : ""}<br/>
                    {props.apartment ? props.apartment : ""}<br/>
                    {props.show === false ?
                        <>
                    <b>TYPE : </b>{props.type}<br/>
                    <b>Floor(s) : </b>{props.floor}
                        </>
                        :
                        ""}
                </div>
            </>
        )
    }
    return (
        <div className="residence_details ">
            <div className="row service_type">
                <div className="col service_type_name">
                    <b>{IV1_PageDetails.TypeOfService}</b>
                </div>
            </div>
            <div className="row ">
                <div className="col origin_dest_details">
                    <AddressRecord addressType={"ORIGIN"} address={IV1_PageDetails.Origin.OriginAddress}
                           description={IV1_PageDetails.Origin.OriginDescription}  apartment={IV1_PageDetails.Origin.OriginApartment}
                                   type={IV1_PageDetails.Origin.OriginType} floor={IV1_PageDetails.Origin.OriginFloor} show={IV1_PageDetails.Origin.Show} />
                    <div className="col residence_col">
                        <b>STOPS</b>
                    </div>
                    {IV1_PageDetails.ExtraStops.length?
                        <div className="col address">{IV1_PageDetails.ExtraStops.map((stop, key) => {
                            return (
                                <div key={key+"extra_stop1"}><p key={key+"extra_stop"}>{stop.Address}</p><br/>
                                    <p key={key+"extra_stop_apartment"}>
                                        {stop.Description? <><b>Description : </b>{stop.Description} <br/></> : ""}
                                        {stop.Apartment? <><b>SUITE/APT : </b> {stop.Apartment}<br/></> : ""}
                                        {stop.Show === false ? stop.Floor ? <><b>Floor(s) : </b>{stop.Floor}</>  : "" : "" }
                                       </p>
                                </div>
                            )
                        })}</div>
                        :
                        <div className="col address">
                            No Extra Stops
                        </div>
                    }
                    <AddressRecord addressType={"DESTINATION"} address={IV1_PageDetails.Destination.DestinationAddress}
                                   description={IV1_PageDetails.Destination.DestinationDescription}
                                   apartment={IV1_PageDetails.Destination.DestinationApartment}
                                   type={IV1_PageDetails.Destination.DestinationType}
                                   floor={IV1_PageDetails.Destination.DestinationFloor}
                                   show={IV1_PageDetails.Destination.Show}/>
                </div>
            </div>
        </div>
    )
}


